
//components 
import Messenger from "./components/Messenger";

function App() {
  return (
   <Messenger />
  );
}

export default App;
